export default __webpack_public_path__ + "56de9bc44b637181d798b00afb59a7fa.svg";